@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Manrope:wght@400;500;600;700&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Cormorant Garamond', Georgia, serif;
  --font-body: 'Manrope', system-ui, sans-serif;
  --font-label: 'Manrope', system-ui, sans-serif;

  --background-50: 0.985 0.006 85;
  --background-100: 0.965 0.01 85;
  --background-200: 0.925 0.015 85;
  --background-300: 0.87 0.02 85;
  --background-400: 0.78 0.02 85;
  --background-500: 0.68 0.02 85;
  --background-600: 0.56 0.02 85;
  --background-700: 0.45 0.02 85;
  --background-800: 0.35 0.02 85;
  --background-900: 0.25 0.015 85;
  --background-950: 0.18 0.01 85;

  --primary-50: 0.97 0.015 160;
  --primary-100: 0.93 0.03 160;
  --primary-200: 0.86 0.05 160;
  --primary-300: 0.76 0.07 160;
  --primary-400: 0.6 0.08 160;
  --primary-500: 0.42 0.07 160;
  --primary-600: 0.36 0.065 160;
  --primary-700: 0.31 0.055 160;
  --primary-800: 0.26 0.045 160;
  --primary-900: 0.21 0.035 160;
  --primary-950: 0.16 0.025 160;

  --accent-50: 0.97 0.02 80;
  --accent-100: 0.94 0.045 80;
  --accent-200: 0.89 0.07 80;
  --accent-300: 0.83 0.1 80;
  --accent-400: 0.77 0.12 78;
  --accent-500: 0.7 0.13 75;
  --accent-600: 0.6 0.12 72;
  --accent-700: 0.5 0.1 70;
  --accent-800: 0.4 0.08 70;
  --accent-900: 0.3 0.06 70;
  --accent-950: 0.22 0.04 70;

  --secondary-50: 0.97 0.012 40;
  --secondary-100: 0.93 0.025 40;
  --secondary-200: 0.86 0.045 40;
  --secondary-300: 0.76 0.065 40;
  --secondary-400: 0.65 0.08 40;
  --secondary-500: 0.52 0.09 40;
  --secondary-600: 0.45 0.085 40;
  --secondary-700: 0.38 0.07 40;
  --secondary-800: 0.31 0.055 40;
  --secondary-900: 0.25 0.04 40;
  --secondary-950: 0.18 0.03 40;

  --foreground-50: 0.97 0.004 160;
  --foreground-100: 0.93 0.006 160;
  --foreground-200: 0.86 0.008 160;
  --foreground-300: 0.76 0.01 160;
  --foreground-400: 0.64 0.012 160;
  --foreground-500: 0.54 0.012 160;
  --foreground-600: 0.45 0.012 160;
  --foreground-700: 0.37 0.012 160;
  --foreground-800: 0.29 0.012 160;
  --foreground-900: 0.22 0.012 160;
  --foreground-950: 0.16 0.012 160;
}

body {
  font-family: var(--font-body);
  background-color: oklch(var(--background-50));
  color: oklch(var(--foreground-950));
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-up { animation: fadeUp 0.9s ease-out both; }
.delay-1 { animation-delay: 0.15s; }
.delay-2 { animation-delay: 0.3s; }
.delay-3 { animation-delay: 0.45s; }